module.exports = __webpack_public_path__ + "img/p57.70a72e6a.png";